import { Component } from '@angular/core';
import {TokenMap} from "../../models/token-map";

@Component({
  selector: 'app-error',
  templateUrl: './error-token.component.html',
  styleUrls: ['./error-token.component.css']
})
export class ErrorTokenComponent {
  errorToken: TokenMap;

  protected buildErrorToken(reference: string, tokenMap: TokenMap[]): void {
    if (tokenMap.length > 0) {
      tokenMap = [];
    }
    this.errorToken = new TokenMap();
    this.errorToken.tokenName = 'vitality.za.ErrorReferenceNumber';
    this.errorToken.tokenValue = reference;
    tokenMap.push(this.errorToken);
  }
}
